import { MODELS_CATALOG_REMOTE_URL } from "@x12i/ai-profiles";

/** Canonical remote models catalog (owned by @x12i/ai-profiles). */
export const DEFAULT_MODELS_CATALOG_URL = MODELS_CATALOG_REMOTE_URL;

/** @deprecated Use {@link DEFAULT_MODELS_CATALOG_URL}. Kept for API compatibility. */
export const DEFAULT_DIRECT_CATALOG_URL = DEFAULT_MODELS_CATALOG_URL;

/** @deprecated Dual OpenRouter catalog removed; unified catalog is the SoT. */
export const DEFAULT_OPENROUTER_CATALOG_URL = DEFAULT_MODELS_CATALOG_URL;

export type CatalogSourceKind = "direct" | "openrouter";
